/* LBCustom — Preview + Edit design NGAY TRONG gio hang / cart drawer (28/09, hoc tu Teeinblue
 * tren pawfecthouse.com — xem memory reference_teeinblue_teardown).
 *
 * snippets/cart-products.liquid da lo phan HTML cho dong co ten khach:
 *   - anh dong hang = anh xem thu cua CHINH don nay (/lbc/v/<ma>.jpg), khong phai anh san pham
 *   - nut  [data-lbc-xem]  duoi anh      -> file nay mo anh lon
 *   - nut  [data-lbc-sua]  duoi thuoc tinh -> file nay mo cua so sua ten
 *
 * Sua ten: tao MA MOI (giong luc them gio o trang san pham) -> cho may chu ghi xong ->
 * /cart/change.js thay thuoc tinh NGAY TREN DONG DO (khong xoa-them nhu Teeinblue, nen dong
 * khong nhay vi tri va mon kem giu nguyen) -> ve lai drawer bang dung cach lb-drawer-suggester
 * dang lam (sections + su kien cart:update co itemCount).
 *
 * Drawer cua Horizon la <dialog> mo bang showModal() = nam o "top layer". Phan tu thuong gan
 * vao <body> se BI DRAWER CHE du z-index bao nhieu -> ca 2 cua so o day cung phai la <dialog>
 * mo bang showModal() (mo sau thi nam tren).
 *
 * LUU Y khi sua: Shopify minify tai san theme va NUOT dau gach cheo nguoc trong chuoi -> moi
 * bieu thuc chinh quy viet dang /.../, khong dung new RegExp('...').
 */
(function () {
  if (window.__lbcCart) return;
  window.__lbcCart = 1;

  var DUONG = '/apps/lbc/cauhinh.json';
  var KHOA_DEM = 'lb:lbc5';            /* dung chung bo nho dem voi lb-custom.js */
  var HAN_DEM = 600000;
  var KHOA_NHAP = 'lbc-nhap';          /* ban nhap ten theo san pham — dung chung voi lb-custom.js */
  var CHO_PHEP = /[^\p{L}\p{M} -;=?-~€£¥©®™°•…–—‘’“”∞]/gu;

  /* ------------------------------------------------------------------ giao dien */
  function css() {
    if (document.getElementById('lbc-cart-css')) return;
    var s = document.createElement('style');
    s.id = 'lbc-cart-css';
    s.textContent = [
      '.lbc-anh{object-fit:contain!important;background:transparent}',
      '.lbc-xem,.lbc-sua{display:inline-flex;align-items:center;gap:5px;margin:6px 0 0;padding:2px 0;border:0;background:none;cursor:pointer;',
      'font:500 12px/1.3 Lora,serif;letter-spacing:.04em;color:#8a6d2f;text-decoration:underline;text-underline-offset:3px}',
      '.lbc-xem{width:100%;justify-content:center}',
      '.lbc-xem svg,.lbc-sua svg{flex:0 0 auto}',
      '.lbc-xem:hover,.lbc-sua:hover{color:#1a1a1a}',
      '.lbc-xem:focus-visible,.lbc-sua:focus-visible{outline:2px solid #c9a55a;outline-offset:2px}',
      /* drawer nen toi (.com): vang dam #8a6d2f chim -> vang sang */
      '.lbc-toi .lbc-xem,.lbc-toi .lbc-sua{color:#c9a55a}',
      '.lbc-toi .lbc-xem:hover,.lbc-toi .lbc-sua:hover{color:#e8e0d0}',
      'dialog.lbc-dlg{border:0;padding:0;background:#fff;color:#1a1a1a;width:min(440px,calc(100vw - 32px));max-height:calc(100vh - 32px);',
      'box-shadow:0 18px 60px rgba(0,0,0,.28);overflow:auto}',
      'dialog.lbc-dlg::backdrop{background:rgba(20,18,14,.62)}',
      '.lbc-dlg__dau{display:flex;align-items:center;justify-content:space-between;padding:14px 16px 10px;border-bottom:1px solid rgba(201,165,90,.35)}',
      '.lbc-dlg__td{margin:0;font:600 13px/1.3 Lora,serif;letter-spacing:2px;text-transform:uppercase}',
      '.lbc-dlg__dong{border:0!important;background:none;cursor:pointer;font:20px/1 Arial,sans-serif;color:#1a1a1a;padding:4px 6px}',
      /* showModal() tu dat con tro vao nut dau tien -> theme ve khung vien quanh nut x; chi hien khi dung ban phim */
      '.lbc-dlg__dong:focus{outline:none;box-shadow:none}',
      '.lbc-dlg__dong:focus-visible{outline:2px solid #c9a55a;outline-offset:2px}',
      '.lbc-dlg__than{padding:14px 16px 16px}',
      '.lbc-dlg__anh{display:block;width:100%;max-width:380px;height:auto;margin:0 auto;background:rgba(26,26,26,.04)}',
      '.lbc-dlg__chu{display:block;margin:8px 0 0;text-align:center;font-family:"Courier Prime",monospace;font-size:.68rem;letter-spacing:.1em;text-transform:uppercase;color:rgba(26,26,26,.5)}',
      '.lbc-dlg__hang{display:flex;align-items:center;gap:10px;margin-top:14px}',
      '.lbc-dlg__o{flex:1;min-width:0;font:1rem/1.4 Lora,serif;padding:9px 12px;border:1px solid rgba(26,26,26,.25);background:#fff;color:#1a1a1a}',
      '.lbc-dlg__o:focus{outline:none;border-color:#c9a55a}',
      '.lbc-dlg__dem{font-family:"Courier Prime",monospace;font-size:.78rem;color:rgba(26,26,26,.65)}',
      '.lbc-dlg__nhac{margin:7px 0 0;font-size:12px;line-height:1.5;color:rgba(26,26,26,.75)}',
      '.lbc-dlg__loi{margin:8px 0 0;font-size:12px;color:#a8321c;min-height:1em}',
      '.lbc-dlg__nut{display:flex;gap:10px;margin-top:14px}',
      '.lbc-dlg__nut button{flex:1;padding:11px 12px;cursor:pointer;font:600 12px/1 Lora,serif;letter-spacing:1.6px;text-transform:uppercase}',
      '.lbc-dlg__luu{background:#c9a55a;border:1px solid #c9a55a;color:#1a1a1a}',
      '.lbc-dlg__luu[disabled]{opacity:.6;cursor:wait}',
      '.lbc-dlg__huy{background:#fff;border:1px solid rgba(26,26,26,.3);color:#1a1a1a}',
      /* NEN TOI (.com) — chep dung bo so do tu khoi #lb-custom tren PDP .com 01/10 (user: "lam style giong PDP"):
         khung vang 5% tren #0a0a12 + vien vang 45%; tieu de Lora 13.5px gian 2.2px; o nhap Courier Prime 16px
         chu kem nen #0f0f1a vien vang; chu thich Lora 10.88px in hoa mo 50%; nut chinh nhu nut mua (Courier Prime dam). */
      '.lbc-toi dialog.lbc-dlg{background:linear-gradient(rgba(201,165,90,.05),rgba(201,165,90,.05)),#0a0a12;color:#e8e0d0;border:1px solid rgba(201,165,90,.45);box-shadow:0 18px 60px rgba(0,0,0,.6)}',
      '.lbc-toi dialog.lbc-dlg::backdrop{background:rgba(0,0,0,.72)}',
      '.lbc-toi .lbc-dlg__dau{border-bottom-color:rgba(201,165,90,.25)}',
      '.lbc-toi .lbc-dlg__td{font:400 13.5px/1.3 Lora,serif;letter-spacing:2.2px;color:#e8e0d0}',
      '.lbc-toi .lbc-dlg__dong{color:#e8e0d0}',
      '.lbc-toi .lbc-dlg__anh{background:transparent}',
      '.lbc-toi .lbc-dlg__chu{font:400 10.88px/1.6 Lora,serif;letter-spacing:.1em;color:rgba(232,224,208,.5)}',
      '.lbc-toi .lbc-dlg__o{font:400 16px/1.4 "Courier Prime",Courier,monospace;letter-spacing:.02em;color:#e8e0d0;background:#0f0f1a;border:1px solid #c9a55a}',
      '.lbc-toi .lbc-dlg__dem{font:400 12.48px/1.6 Lora,serif;color:rgba(232,224,208,.65)}',
      '.lbc-toi .lbc-dlg__nhac{font:400 12px/1.5 Lora,serif;color:rgba(232,224,208,.75)}',
      '.lbc-toi .lbc-dlg__loi{color:#e8977f}',
      '.lbc-toi .lbc-dlg__nut button{font:700 13px/1 "Courier Prime",monospace;letter-spacing:.12em}',
      '.lbc-toi .lbc-dlg__luu{background:#c9a55a;border-color:#c9a55a;color:#0a0a12}',
      '.lbc-toi .lbc-dlg__huy{background:transparent;border:1px solid rgba(232,224,208,.3);color:#e8e0d0}',
      '.lbc-toi .lbc-dlg__than p{color:#e8e0d0}',
    ].join('');
    document.head.appendChild(s);
    try {
      var c = getComputedStyle(document.body).backgroundColor.match(/\d+/g);
      if (c && (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) < 90) document.documentElement.classList.add('lbc-toi');
    } catch (e) {}
  }

  function taoDialog(tieuDe) {
    var d = document.createElement('dialog');
    d.className = 'lbc-dlg';
    d.innerHTML = '<div class="lbc-dlg__dau"><p class="lbc-dlg__td"></p>' +
      '<button type="button" class="lbc-dlg__dong" aria-label="Close">×</button></div><div class="lbc-dlg__than"></div>';
    d.querySelector('.lbc-dlg__td').textContent = tieuDe;
    d.querySelector('.lbc-dlg__dong').addEventListener('click', function () { d.close(); });
    /* bam ra nen toi = dong */
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    d.addEventListener('close', function () { setTimeout(function () { d.remove(); }, 0); });
    document.body.appendChild(d);
    return d;
  }

  function mo(d) {
    try { d.showModal(); } catch (e) { d.setAttribute('open', ''); }
  }

  /* ------------------------------------------------------------------ Preview */
  function moXem(url, ten, nut) {
    css();
    var d = taoDialog('Your design');
    var than = d.querySelector('.lbc-dlg__than');
    var c = document.createElement('span');
    c.className = 'lbc-dlg__chu';
    c.textContent = ten ? 'Printed with "' + ten + '"' : 'Preview — printed on your artwork';
    function anhJpg() {
      var i = document.createElement('img');
      i.className = 'lbc-dlg__anh';
      i.alt = 'Your personalized design' + (ten ? ' — ' + ten : '');
      /* anh trong gio chi 250px -> o day lay ban goc (may chu da nen san, cache 1 ngay) */
      i.src = url;
      return i;
    }
    /* Nen toi (.com): anh JPG cua may chu co nen TRANG -> thanh o trang giua cua so toi. Ve thang tui len
       canvas trong suot tu mau + ten, giong het khoi xem thu tren PDP. Loi gi thi quay ve anh JPG. */
    var hang = nut && nut.closest && nut.closest('tr');
    var nutSua = hang && hang.querySelector('[data-lbc-sua]');
    var handle = nutSua && nutSua.getAttribute('data-handle');
    if (document.documentElement.classList.contains('lbc-toi') && handle && ten) {
      var cv = document.createElement('canvas');
      cv.className = 'lbc-dlg__anh';
      var cu = hang.querySelector('img.lbc-anh');
      if (cu && cu.naturalWidth) cv.style.aspectRatio = cu.naturalWidth + ' / ' + cu.naturalHeight;
      than.appendChild(cv);
      than.appendChild(c);
      veMau(cv, handle, ten).catch(function () { than.replaceChild(anhJpg(), cv); });
    } else {
      than.appendChild(anhJpg());
      than.appendChild(c);
    }
    mo(d);
  }

  /* Nap cau hinh + mockup + font cua mau gan voi san pham, ve ten len canvas. */
  function veMau(canvas, handle, ten) {
    return napCauHinh().then(function (tatCa) {
      var cfg = tatCa && tatCa[handle];
      if (!cfg || !cfg.o || !cfg.o.length) throw new Error('khong co mau');
      var anh = null, mask = null;
      return Promise.all([
        napAnh(cfg.mockup).then(function (x) { anh = x; }),
        cfg.mask ? napAnh(cfg.mask).then(function (x) { mask = x; }) : null,
      ].concat(cfg.o.map(function (x) { return napFont(x.fontUrl); }))).then(function () {
        if (!anh) throw new Error('khong tai duoc mockup');
        canvas.style.aspectRatio = '';
        ve(canvas, cfg, anh, mask, ten);
      });
    });
  }

  /* ------------------------------------------------------------------ du lieu mau */
  function napCauHinh() {
    try {
      var kho = JSON.parse(sessionStorage.getItem(KHOA_DEM) || 'null');
      if (kho && kho.t && Date.now() - kho.t < HAN_DEM && kho.d) return Promise.resolve(kho.d);
    } catch (e) {}
    return fetch(DUONG, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (j) {
        try { sessionStorage.setItem(KHOA_DEM, JSON.stringify({ t: Date.now(), d: j })); } catch (e) {}
        return j;
      })
      .catch(function () { return {}; });
  }

  var fontDaNap = {};
  function napFont(url) {
    if (fontDaNap[url]) return fontDaNap[url];
    var ho = 'lbc' + url.replace(/\W/g, '');
    if (!window.FontFace) { fontDaNap[url] = Promise.resolve(null); return fontDaNap[url]; }
    fontDaNap[url] = new FontFace(ho, 'url(' + url + ')').load()
      .then(function (f) { document.fonts.add(f); return ho; })
      .catch(function () { return null; });
    return fontDaNap[url];
  }
  function napAnh(url) {
    return new Promise(function (ok) {
      if (!url) return ok(null);
      var i = new Image();
      i.onload = function () { ok(i); };
      i.onerror = function () { ok(null); };
      i.src = url;
    });
  }

  /* Ve mockup + o chu + mask. CUNG bo so voi veXem() trong lb-custom.js (trang san pham)
     va voi bo render cua may chu — sua cho nay thi sua ca hai kia. */
  function ve(canvas, cfg, anh, mask, ten) {
    var RONG = Math.min(760, anh.width);
    var ty = RONG / anh.width;
    canvas.width = RONG;
    canvas.height = Math.round(anh.height * ty);
    var x = canvas.getContext('2d');
    x.clearRect(0, 0, canvas.width, canvas.height);
    x.drawImage(anh, 0, 0, canvas.width, canvas.height);
    if (ten) {
      (cfg.o || []).forEach(function (o) {
        var chu = (o.hoa ? ten.toUpperCase() : ten);
        chu = (o.truoc || '') + chu + (o.sau || '');
        var oX = o.x * canvas.width, oY = o.y * canvas.height;
        var oW = o.w * canvas.width, oH = o.h * canvas.height;
        var ho = '"lbc' + o.fontUrl.replace(/\W/g, '') + '", serif';
        var tran = oH * (o.coMax || 1), san = oH * (o.coMin || 0.25);
        var co = tran;
        for (; co > san; co -= 1) { x.font = co + 'px ' + ho; if (x.measureText(chu).width <= oW) break; }
        x.save();
        x.translate(oX + oW / 2, oY + oH / 2);
        if (o.rot) x.rotate(o.rot * Math.PI / 180);
        x.font = co + 'px ' + ho;
        x.textBaseline = 'middle';
        x.textAlign = o.canh || 'center';
        var px = o.canh === 'left' ? -oW / 2 : o.canh === 'right' ? oW / 2 : 0;
        if (o.vienDay > 0) {   /* vien chu — chep dung ve.js cua may chu */
          x.lineWidth = (o.vienDay / 100) * co;
          x.strokeStyle = o.vienMau || '#000';
          x.lineJoin = 'round';
          x.strokeText(chu, px, 0);
        }
        x.fillStyle = o.mau || '#000';
        x.fillText(chu, px, 0);
        x.restore();
      });
    }
    if (mask) x.drawImage(mask, 0, 0, canvas.width, canvas.height);
  }

  function maMoi() {
    var chu = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789', r = '', a = new Uint8Array(12);
    (window.crypto || window.msCrypto).getRandomValues(a);
    for (var i = 0; i < 12; i++) r += chu.charAt(a[i] % chu.length);
    return r;
  }

  /* Dang ky ma moi va CHO may chu ghi xong (khac trang san pham: o do trang sap chuyen nen
     ban-va-quen; o day drawer ve lai ngay va tai /lbc/v/<ma>.jpg lien, chua ghi thi 404). */
  function dangKy(cfg, ma, ten, handle) {
    var goi = JSON.stringify({ ma: ma, mau: cfg.mau, ten: ten, handle: handle });
    var api = cfg.api || 'https://api.litborne.co/lbc';
    function thu(url, dung) {
      return fetch(url, { method: 'POST', body: goi, credentials: dung ? 'same-origin' : 'omit', headers: { 'Content-Type': 'text/plain' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('dat ' + r.status)); });
    }
    return thu('/apps/lbc/dat', true).catch(function () { return thu(api + '/dat', false); });
  }

  function linkMoi(cfg, ma) {
    var api = cfg.api || 'https://api.litborne.co/lbc';
    var p = { Preview: api + '/v/' + ma + '.jpg', _Production: api + '/in/' + ma };
    for (var i = 2; i <= (cfg.soMat || 1); i++) p['_Production ' + i] = api + '/in/' + ma + '/' + i;
    return p;
  }

  /* ------------------------------------------------------------------ ve lai gio */
  function sectionIds() {
    var s = [];
    document.querySelectorAll('cart-items-component[data-section-id],cart-icon-component[data-section-id],cart-drawer-component[data-section-id]')
      .forEach(function (el) { if (s.indexOf(el.dataset.sectionId) < 0) s.push(el.dataset.sectionId); });
    return s;
  }
  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (sid) {
      var html = sections[sid];
      if (typeof html !== 'string' || !html.length) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      document.querySelectorAll('[data-section-id="' + sid + '"]').forEach(function (el) {
        var src = parsed.querySelector('[data-section-id="' + sid + '"]') || parsed.body.firstElementChild;
        if (src) el.innerHTML = src.innerHTML;
      });
    });
  }
  function baoGioDoi(cart, sections, sua) {
    var n = cart && typeof cart.item_count === 'number' ? cart.item_count : undefined;
    if (n !== undefined) { try { sessionStorage.setItem('cart-count', JSON.stringify({ value: n, timestamp: Date.now() })); } catch (e) {} }
    var ev = new Event('cart:update', { bubbles: true });
    /* itemCount BAT BUOC — thieu la cart-icon cua theme coi la 0 va an so tren bieu tuong.
       lbc: {handle, tenCu, tenMoi} — lb-custom.js tren trang san pham dung de doi o nhap theo (user 01/10). */
    ev.detail = { resource: cart, sourceId: 'lbc-edit', data: { source: 'lbc-edit', itemCount: n, sections: sections || {}, lbc: sua || null } };
    document.dispatchEvent(ev);
  }

  function ghiNhap(handle, ten) {
    try {
      var ds = JSON.parse(localStorage.getItem(KHOA_NHAP) || '[]').filter(function (x) { return x && x.h !== handle; });
      ds.push({ h: handle, ten: ten, t: Date.now() });
      localStorage.setItem(KHOA_NHAP, JSON.stringify(ds.slice(-10)));
    } catch (e) {}
  }

  /* ------------------------------------------------------------------ Edit design */
  function moSua(nut) {
    css();
    var key = nut.getAttribute('data-key');
    var handle = nut.getAttribute('data-handle');
    var tenCu = nut.getAttribute('data-ten') || '';
    var d = taoDialog('Edit your design');
    var than = d.querySelector('.lbc-dlg__than');
    than.innerHTML =
      '<canvas class="lbc-dlg__anh" aria-label="Live preview of your design"></canvas>' +
      '<span class="lbc-dlg__chu">Preview — printed on your artwork</span>' +
      '<div class="lbc-dlg__hang"><input type="text" class="lbc-dlg__o" autocomplete="off" spellcheck="false" aria-label="Name to print">' +
      '<span class="lbc-dlg__dem"></span></div>' +
      "<p class='lbc-dlg__nhac'>Printed exactly as typed. Letters, numbers and symbols are all fine.</p>" +
      '<p class="lbc-dlg__loi" role="alert"></p>' +
      '<div class="lbc-dlg__nut"><button type="button" class="lbc-dlg__huy">Cancel</button>' +
      '<button type="button" class="lbc-dlg__luu">Save changes</button></div>';
    var canvas = than.querySelector('canvas');
    var o = than.querySelector('.lbc-dlg__o');
    var dem = than.querySelector('.lbc-dlg__dem');
    var loi = than.querySelector('.lbc-dlg__loi');
    var luu = than.querySelector('.lbc-dlg__luu');
    than.querySelector('.lbc-dlg__huy').addEventListener('click', function () { d.close(); });
    o.value = tenCu;
    /* giu cho khung anh bang chinh anh xem thu dang co (khong nhay khi mockup tai xong) */
    var anhCu = nut.closest('tr') && nut.closest('tr').querySelector('img.lbc-anh');
    if (anhCu && anhCu.naturalWidth) canvas.style.aspectRatio = anhCu.naturalWidth + ' / ' + anhCu.naturalHeight;
    mo(d);

    var cfg = null, anh = null, mask = null, MAX = 10;
    function loc() {
      var t = o.value.replace(CHO_PHEP, '').replace(/\s{2,}/g, ' ').slice(0, MAX);
      if (t !== o.value) o.value = t;
      dem.textContent = t.trim().length + '/' + MAX;
      return t.trim();
    }
    function veLai() { if (cfg && anh) ve(canvas, cfg, anh, mask, loc()); else loc(); }
    o.addEventListener('input', function () { loi.textContent = ''; veLai(); });
    o.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); luu.click(); } });

    napCauHinh().then(function (tatCa) {
      cfg = tatCa && tatCa[handle];
      if (!cfg || !cfg.o || !cfg.o.length) { loi.textContent = 'This design can no longer be edited here. Please remove it and add it again.'; luu.disabled = true; return; }
      MAX = cfg.max || 10;
      o.maxLength = MAX;
      loc();
      return Promise.all([
        napAnh(cfg.mockup).then(function (x) { anh = x; }),
        cfg.mask ? napAnh(cfg.mask).then(function (x) { mask = x; }) : null,
      ].concat(cfg.o.map(function (x) { return napFont(x.fontUrl); }))).then(function () {
        canvas.style.aspectRatio = '';
        veLai();
      });
    });
    setTimeout(function () { try { o.focus(); o.setSelectionRange(o.value.length, o.value.length); } catch (e) {} }, 60);

    luu.addEventListener('click', function () {
      var ten = loc();
      if (!ten) { loi.textContent = 'Please enter a name.'; o.focus(); return; }
      if (ten === tenCu) { d.close(); return; }
      if (!cfg) return;
      luu.disabled = true; luu.textContent = 'Saving…';
      var ma = maMoi();
      dangKy(cfg, ma, ten, handle)
        .then(function () { return fetch('/cart.js?_lbc=' + Date.now(), { cache: 'no-store' }).then(function (r) { return r.json(); }); })
        .then(function (gio) {
          var dong = null;
          (gio.items || []).forEach(function (it) { if (it.key === key) dong = it; });
          if (!dong) throw new Error('Could not find this item in your cart. Please refresh and try again.');
          /* /cart/change THAY TOAN BO thuoc tinh -> phai giu lai moi thu cu (_attach_source, _lbc_tier…),
             chi doi ten + link, va bo cac link file in cu (so mat co the khac). */
          var props = {};
          Object.keys(dong.properties || {}).forEach(function (k) { if (!/^_Production/.test(k)) props[k] = dong.properties[k]; });
          props.Name = ten;
          var l = linkMoi(cfg, ma);
          Object.keys(l).forEach(function (k) { props[k] = l[k]; });
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: dong.quantity, properties: props, sections: sectionIds().join(','), sections_url: window.location.pathname }),
          }).then(function (r) { return r.json(); });
        })
        .then(function (data) {
          if (!data || data.status) throw new Error((data && (data.description || data.message)) || 'Could not update your cart.');
          applySections(data.sections);
          baoGioDoi(data, data.sections, { handle: handle, tenCu: tenCu, tenMoi: ten });
          ghiNhap(handle, ten);
          d.close();
        })
        .catch(function (e) {
          loi.textContent = (e && e.message) || 'Something went wrong. Please try again.';
          luu.disabled = false; luu.textContent = 'Save changes';
        });
    });
  }

  /* ------------------------------------------------------------------ bat su kien */
  /* Uy quyen tren document: drawer bi ve lai lien tuc (sections, lb-set, summer26), gan
     truc tiep vao nut se mat sau moi lan ve. */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-lbc-xem],[data-lbc-sua]');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    if (t.hasAttribute('data-lbc-xem')) moXem(t.getAttribute('data-lbc-xem'), t.getAttribute('data-lbc-ten'), t);
    else moSua(t);
  }, true);

  /* Cho lb-custom.js (trang san pham) dung chung khung cua so + bo ve cho popup khoi phuc ten. */
  window.lbcDialog = function (tieuDe) { css(); return taoDialog(tieuDe); };
  window.lbcMo = mo;
  window.lbcVe = ve;

  /* 03/10: anh nho trong drawer — trang san pham da luu san ban thu nho cua preview theo ma thiet ke (lb-custom.js
     luuNho). Dong gio vua ve ra ma anh may chu chua tai xong thi gan ngay ban do -> khong thay o trong ~2s. */
  function apNho(goc) {
    if (!goc || !goc.querySelectorAll) return;
    var ds = goc.matches && goc.matches('img.lbc-anh') ? [goc] : goc.querySelectorAll('img.lbc-anh');
    Array.prototype.forEach.call(ds, function (img) {
      if (img.getAttribute('data-lbc-nho')) return;
      var m = /\/t\/([A-Za-z0-9]{12})\.(webp|png)/.exec(img.getAttribute('src') || '');
      if (!m || (img.complete && img.naturalWidth)) return;
      var u = (window.__lbcNho || {})[m[1]];
      if (!u) { try { u = sessionStorage.getItem('lbc-nho-' + m[1]); } catch (e) {} }
      if (!u) return;
      img.setAttribute('data-lbc-nho', '1');
      img.src = u;
    });
  }
  apNho(document);
  if (window.MutationObserver) {
    /* Horizon cap nhat drawer bang MORPH: giu nguyen the img, chi doi thuoc tinh src -> phai nghe ca thay doi src */
    new MutationObserver(function (ds) {
      ds.forEach(function (d) {
        if (d.type === 'attributes') { if (d.target.matches && d.target.matches('img.lbc-anh') && !/^data:/.test(d.target.getAttribute('src') || '')) { d.target.removeAttribute('data-lbc-nho'); apNho(d.target); } return; }
        Array.prototype.forEach.call(d.addedNodes, function (n) { if (n.nodeType === 1) apNho(n); });
      });
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  }

  css();
})();
